import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Garantia() {
  return <Section background="white" data-id="element-106">
      <div className="flex flex-col items-center text-center" data-id="element-107">
        <ShieldCheck className="w-16 h-16 text-stone-900 mb-6" data-id="element-108" />
        <h2 className="text-3xl font-bold text-stone-900 mb-6" data-id="element-109">
          Garantía 7 días — PDF útil o te devolvemos
        </h2>
        <p className="text-lg text-stone-600 max-w-2xl mb-8" data-id="element-110">
          Descargalo, revisalo y usalo. Si en 7 días no te resultó práctico para
          organizar tu semana, escribinos y te devolvemos el dinero.
        </p>
        <p className="font-bold text-stone-900" data-id="element-111">
          Sin preguntas. Sin formularios largos.
          <br data-id="element-112" />
          <span className="text-emerald-700" data-id="element-113">El riesgo es nuestro.</span>
        </p>
      </div>
    </Section>;
}